import React from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { Delete, Add, Store, Description, LocalShipping, ShoppingBasket, TrendingUp, AttachMoney } from "@material-ui/icons";
import { FieldArray } from "formik";
import styled, { keyframes } from "styled-components";

const fields = [
	{
		name: "branchId",
		label: "Filial Id",
		type: "number",
	},
	{
		name: "seqNF",
		label: "Sequência NF",
		type: "number",
	},
	{
		name: "usageNF",
		label: "Utilização NF",
		type: "number",
	},
	{
		name: "seqNFRet",
		label: "Sequência Devolução",
		type: "number",
	},
	{
		name: "usageNFRet",
		label: "Utilização Devolução",
		type: "number",
	},
	{
		name: "usageAdto",
		label: "Utilização Adiantamento",
		type: "number",
	},
	{
		name: "itemAdto",
		label: "Item Adiantamento",
		type: "text",
	},
];

function TabViceri({ values, errors, handleChange, touched, initialValues }) {
	const viceri = values.viceri ? values.viceri : [];

	const getFieldIcon = (fieldName) => {
		const icons = {
			branchId: <Store style={{ fontSize: '18px', marginRight: '8px', color: '#9b59b6' }} />,
			seqNF: <Description style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />,
			usageNF: <ShoppingBasket style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />,
			seqNFRet: <LocalShipping style={{ fontSize: '18px', marginRight: '8px', color: '#e67e22' }} />,
			usageNFRet: <TrendingUp style={{ fontSize: '18px', marginRight: '8px', color: '#16a085' }} />,
			usageAdto: <AttachMoney style={{ fontSize: '18px', marginRight: '8px', color: '#f39c12' }} />,
			itemAdto: <Description style={{ fontSize: '18px', marginRight: '8px', color: '#e74c3c' }} />,
		};
		return icons[fieldName] || null;
	};

	return (
		<ModernContainer>
			<FieldArray name="viceri">
				{({ push, remove }) => (
					<>
						{viceri.map((_, index) => {
							return (
								<ViceriCard key={index} index={index}>
									<CardHeader>
										<CardTitle>
											<Store style={{ marginRight: '8px' }} />
											Configuração Viceri #{index + 1}
										</CardTitle>
										<DeleteButton type="button" onClick={() => remove(index)}>
											<Delete style={{ marginRight: '4px', fontSize: '18px' }} />
											Remover
										</DeleteButton>
									</CardHeader>

									<FormGrid>
										{fields.map((field) => {
											return (
												<StyledFieldContainer key={`${index}-${field.name}`}>
													<FieldLabel>
														{getFieldIcon(field.name)}
														{field.label}
													</FieldLabel>
													<TextField
														fullWidth
														InputLabelProps={{ shrink: true }}
														name={`viceri[${index}].${field.name}`}
														placeholder={field.label}
														value={values.viceri[index][field.name]}
														onChange={handleChange}
														error={
															touched &&
															touched.viceri &&
															touched.viceri[index] &&
															touched.viceri[index][field.name] &&
															Boolean(
																errors &&
																	errors.viceri &&
																	errors.viceri[index] &&
																	errors.viceri[index][field.name]
															)
														}
														helperText={
															touched &&
															touched.viceri &&
															touched.viceri[index] &&
															touched.viceri[index][field.name] &&
															errors &&
															errors.viceri &&
															errors.viceri[index] &&
															errors.viceri[index][field.name]
														}
														autoComplete="off"
														type={field.type}
														variant="outlined"
													/>
												</StyledFieldContainer>
											);
										})}
									</FormGrid>
								</ViceriCard>
							);
						})}
						<AddButtonContainer>
							<AddButton type="button" onClick={() => push(initialValues)}>
								<Add style={{ marginRight: '8px', fontSize: '20px' }} />
								Adicionar Nova Configuração
							</AddButton>
						</AddButtonContainer>
					</>
				)}
			</FieldArray>
		</ModernContainer>
	);
}

export default TabViceri;

// Animações
const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const ModernContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	font-family: 'Mulish', sans-serif;
`;

const ViceriCard = styled.div`
	background: white;
	border-radius: 16px;
	padding: 24px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	border: 1px solid #e8e8e8;
	animation: ${fadeIn} 0.5s ease;
	animation-delay: ${props => props.index * 0.1}s;
	animation-fill-mode: both;
	transition: all 0.3s ease;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		border-color: #d0d0d0;
	}
`;

const CardHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
	padding-bottom: 16px;
	border-bottom: 2px solid #f0f0f0;
`;

const CardTitle = styled.h3`
	font-size: 18px;
	font-weight: 700;
	color: #2c3e50;
	margin: 0;
	display: flex;
	align-items: center;
	font-family: 'Mulish', sans-serif;
`;

const DeleteButton = styled.button`
	background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
	color: white;
	border: none;
	border-radius: 10px;
	padding: 8px 16px;
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;
	display: flex;
	align-items: center;
	transition: all 0.3s ease;
	font-family: 'Mulish', sans-serif;
	box-shadow: 0 2px 8px rgba(231, 76, 60, 0.3);

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(231, 76, 60, 0.4);
	}

	&:active {
		transform: translateY(0);
	}
`;

const FormGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 20px;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

const StyledFieldContainer = styled.div`
	display: flex;
	flex-direction: column;

	.MuiOutlinedInput-root {
		border-radius: 10px;
		transition: all 0.3s ease;

		&:hover {
			box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
		}

		&.Mui-focused {
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
		}
	}

	.MuiInputLabel-outlined {
		font-family: 'Mulish', sans-serif;
		font-weight: 500;
	}

	.MuiOutlinedInput-input {
		font-family: 'Mulish', sans-serif;
	}
`;

const FieldLabel = styled.label`
	font-size: 14px;
	font-weight: 600;
	color: #2c3e50;
	margin-bottom: 8px;
	display: flex;
	align-items: center;
	font-family: 'Mulish', sans-serif;
`;

const AddButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 8px;
`;

const AddButton = styled.button`
	background: linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%);
	color: white;
	border: none;
	border-radius: 12px;
	padding: 14px 32px;
	font-size: 15px;
	font-weight: 600;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.3s ease;
	box-shadow: 0 4px 12px rgba(142, 68, 173, 0.3);
	font-family: 'Mulish', sans-serif;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(142, 68, 173, 0.4);
	}

	&:active {
		transform: translateY(0);
	}
`;
